import css from 'styled-jsx/css';

export default css`
  .expired_container {
    background-color: #f1f1f1;
  }

  .expired_message {
    padding: 1em;
    overflow: hidden;
    background-color: #fffad5;
  }

  .expired_message > p {
    color: #333;
    margin: 0;
    line-height: 1.2;
  }

  .expired_message.hidding {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 0.5s, opacity 0.5s linear, background-color 0.5s linear;
  }
`;



// WEBPACK FOOTER //
// ./app/Serp/components/ExpiredAd/styles.js